export interface CloudStorageUsage {
  usedBytes: number;
  fileBytes: number;
  documentBytes: number;
  pendingBytes: number;
  limitBytes: number | null;
  remainingBytes: number | null;
}

export const formatStorage = (bytes: number) => {
  if (bytes < 1024) return `${Math.round(bytes)} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let value = bytes / 1024;
  let unit = units[0];
  for (let index = 1; index < units.length && value >= 1024; index += 1) { value /= 1024; unit = units[index]; }
  return `${value.toLocaleString('th-TH', { maximumFractionDigits: value >= 100 ? 0 : value >= 10 ? 1 : 2 })} ${unit}`;
};

export const cloudStoragePercent = (usage: CloudStorageUsage) => usage.limitBytes === null ? 0
  : usage.limitBytes <= 0 ? (usage.usedBytes > 0 ? 100 : 0) : Math.min(100, Math.max(0, usage.usedBytes / usage.limitBytes * 100));
